import * as zod from 'zod';

import { ContentBlock } from './contentBlock';

export const AgentCompactionData = zod.object({
  id: zod.string(),
  sessionID: zod.string(),
  compactedThroughSequence: zod.number().int().nonnegative(),
  summary: zod.array(ContentBlock),
  tokensSummarized: zod.number().int().nullable(),
  model: zod.string().nullable(),
  createdAt: zod.string(),
});

export type AgentCompactionData = zod.infer<typeof AgentCompactionData>;

export const AgentCompactionCreateInput = zod.object({
  sessionID: zod.string(),
  compactedThroughSequence: zod.number().int().nonnegative(),
  summary: zod.array(ContentBlock),
  tokensSummarized: zod.number().int().nullable().optional(),
  model: zod.string().nullable().optional(),
});

export type AgentCompactionCreateInput = zod.infer<
  typeof AgentCompactionCreateInput
>;
